import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import styles from './styles'
import { getCollection } from 'src/reducers/collection/action'
import { useDispatch, useSelector } from 'react-redux'
import LandingPageEditor from 'src/components/landing-page/landing-page-editor'
import PathDetail from './path-detail'
import PortalPage from './portal-page'
import usePortalPageEditing from './portal-page/usePortalPageEditing'

const Collection = props => {
  const { classes } = props
  const { id, page, subPage } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const collection = useSelector(state => state.collection.collection)
  const isShowcase = collection?.type === 1
  // ?portalPage={id}: the editor edits that portal page instead of the showcase.
  const portalPageReady = usePortalPageEditing(
    subPage === 'editor'
      ? new URLSearchParams(location.search).get('portalPage')
      : null,
    id,
  )
  useEffect(() => {
    if (id !== collection?.id) {
      dispatch(
        getCollection(id, () => {
          setLoading(false)
        }),
      )
    } else {
      setLoading(false)
    }

    if (page == undefined) {
      history.push(`/collection/${id}/mini-courses`)
    }
  }, [id, dispatch, history, page])
  if (loading) return null

  // The showcase collection is the workspace portal; the full-screen landing
  // page editor (subPage "editor") is shared by both.
  if (subPage !== 'editor') return isShowcase ? <PortalPage /> : <PathDetail />
  if (!portalPageReady) return null

  return (
    <div className={classes.editor}>
      <LandingPageEditor />
    </div>
  )
}

export default withStyles(styles)(Collection)
